import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AccountContext from '../../contexts/AccountContext';
import useRouting from '../../hooks/useRouting';

import FeatureTogglesContext from '../../contexts/FeatureTogglesContext';
import NotificationBanner from '../NotificationBanner';

const startAdornmentIcon = (
  <svg className="icon" role="img">
    <use xlinkHref="#icon-settings" />
  </svg>
);

function BannerComponent({ message }: { message: string }) {
  const { t } = useTranslation();
  const { r } = useRouting();
  return (
    <NotificationBanner variant="danger" startAdornmentIcon={startAdornmentIcon}>
      <span
        dangerouslySetInnerHTML={{
          __html: t(message, {
            redirectUrl: `${r('my-account')}/${r('my-account.linked-accounts')}`,
          }),
        }}
      />
    </NotificationBanner>
  );
}

export default function SmsSyncNotificationBanner() {
  const {
    account: { smartschoolSchools },
  } = useContext(AccountContext);

  const { ONE_ROSTER_SYNC_BANNER } = useContext(FeatureTogglesContext);

  const adminSchool = smartschoolSchools.find(smsSchool => smsSchool.userIsAdmin);
  if (ONE_ROSTER_SYNC_BANNER && adminSchool) {
    if (!adminSchool.oneRoster?.enabled) {
      return <BannerComponent message="COMPONENTS.NOTIFICATION_BAR.NO_SMARTSCHOOL_SYNC" />;
    }
    if (adminSchool.isSyncStale) {
      return <BannerComponent message="COMPONENTS.NOTIFICATION_BAR.STALE_SMARTSCHOOL_SYNC" />;
    }
  }

  return null;
}
